<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config">
    <!-- 订单详情 -->
    <template #ORDERDETAIL="{ params, visible }">
      <order v-if="visible" :orderDetails="params.dataDetails" :pageText="params.pageText" :footer-hide="false"></order>
    </template>
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getAbnormalList,
  getOperatorList
  // , getDetails
} from "@/api/storage/homeAbnormal";
import order from "_c/order-details";
import cTable from "@/base/common/index";
import { getAllClient } from "@/api/user/client";
import { getWarehouse } from "@/api/storage/warehouse";
import { getOrderDetails } from "@/api/order/list";
export default {
  name: "homeAbnormal",
  components: {
    cTable,
    order
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "clientId")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "create_id")
        item.options = (await getOperatorList()).data.payload;
    });
  },
  data() {
    return {
      methods: {
        list: getAbnormalList,
        getOrderDetails
        // getDetails
      },
      config: {
        height: 630
      },
      modals: {
        orderDetail: {
          contentSlot: "ORDERDETAIL",
          config: {
            listFn: "list",
            modalBind: {
              width: "80%",
              styles: {
                top: "5%"
              }
            }
          },
          footer: {
            show: false
          }
        },
        add: {
          footer: {
            show: () => false
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true
            }
          },
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$t("barCode"),
                key: "bar_code"
              },
              {
                name: () => this.$t("skuName"),
                key: "sku_name"
              },
              {
                name: () => this.$t("doublePrice"),
                key: "declaration_amount"
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "datetime",
              style: {
                width: "150px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "datetime",
              style: {
                width: "150px"
              }
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },
          {
            key: "clientId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: 'warehouse_id',
            placeholder() {
              return this.$tz('请选择,仓库')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getWarehouse',
            optionsKey: '',
          },
          {
            key: "is_down",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("down");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ]
          },
          {
            key: "create_type",
            component: "Select",
            placeholder() {
              return this.$t("operate") + this.$t("type");
            },
            clearable: true,
            options: [
              { label: this.$t("up") + this.$t("operate"), value: "on_user" },
              { label: this.$t("down") + this.$t("operate"), value: "in_user" }
            ]
          },
          {
            key: "create_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("operate");
            },
            clearable: true,
            options: []
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60
        },
        {
          name: () => this.$t("orderNum"),
          key: "airway_number",
          fixed: "left",
          copy: true,
          width: 160,
          header: {
            copy: true //头部复制
          },
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({ row }) {
              this.$page
                .handleRequestMethods("getOrderDetails", row.airway_number)
                .then(res => {
                  this.$page.getModal("orderDetail").open(
                    {
                      dataDetails: res.payload
                    },
                    function () {
                      this.setTitle(row.airway_number);
                    }
                  );
                });
            }
          }
        },
        {
          name: () => this.$t("location_t"),
          key: "location",
          align: "center"
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center"
        },
        {
          name: () => this.$t("仓库"),
          key: "warehouse",
          align: "center"
        },
        {
          name: () => this.$t("up") + this.$t("time"),
          key: "on_time",
          align: "center"
        },
        {
          name: () => this.$t("up") + this.$t("operate"),
          key: "on_user",
          align: "center"
        },
        {
          name: () => this.$t("down") + this.$t("time"),
          key: "in_time",
          align: "center"
        },
        {
          name: () => this.$t("down") + this.$t("operate"),
          key: "in_user",
          align: "center"
        }
      ]
    };
  }
};
</script>
